var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { getErrorMessage, useMutation, useShowFlag } from "@atlassiansox/microscopekit";
export function useMutationUI(_a) {
    var mutation = _a.mutation, options = _a.options, successMessage = _a.successMessage, errorMessage = _a.errorMessage;
    var showFlag = useShowFlag();
    var defaultOptions = {
        onError: function (error) {
            console.error(error);
            showFlag({
                type: "error",
                title: "Error",
                message: errorMessage || getErrorMessage(error)
            });
            if (options === null || options === void 0 ? void 0 : options.onError) {
                options.onError(error);
            }
        },
        onCompleted: function (data) {
            showFlag({
                type: "success",
                title: "Success",
                message: successMessage || "Action successful"
            });
            if (options === null || options === void 0 ? void 0 : options.onCompleted) {
                options.onCompleted(data);
            }
        }
    };
    var _b = __read(useMutation(mutation, __assign(__assign({}, options), defaultOptions)), 2), mutate = _b[0], _c = _b[1], loading = _c.loading, data = _c.data, error = _c.error;
    return { mutate: mutate, data: data, error: error, isLoading: loading };
}
